import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Calendar, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ArticlesSection() {
  const [articles, setArticles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/blog`).then(({ data }) => setArticles(data.slice(0, 3))).catch(() => {});
  }, []);

  const resolveImgUrl = (url) => {
    if (!url) return null;
    if (url.startsWith("/")) return `${API.replace("/api", "")}${url}`;
    return url;
  };

  if (articles.length === 0) return null;

  return (
    <section id="articles" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-14">
          <div>
            <span className="text-xs font-sans font-medium uppercase tracking-[0.2em] text-[#C47C5D] mb-3 block">
              Knowledge Center
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-light tracking-tight text-[#2A3324]">
              Latest Research & Insights
            </h2>
          </div>
          <button
            onClick={() => navigate("/blog")}
            className="hidden md:flex items-center gap-2 text-sm font-sans font-medium text-[#5C715E] hover:text-[#4A5A4B] transition-colors"
          >
            View All Articles <ArrowRight size={16} />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {articles.map((a) => (
            <article
              key={a.id}
              onClick={() => navigate(`/blog/${a.slug}`)}
              className="group cursor-pointer"
            >
              <div className="rounded-2xl overflow-hidden border border-[#2A3324]/5 bg-[#F7F5F0] hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                {a.featured_image_url ? (
                  <img
                    src={resolveImgUrl(a.featured_image_url)}
                    alt={a.title}
                    className="w-full h-48 object-cover"
                  />
                ) : (
                  <div className="w-full h-48 bg-gradient-to-br from-[#5C715E]/10 to-[#C47C5D]/10 flex items-center justify-center">
                    <span className="text-5xl font-serif text-[#2A3324]/10">{a.title?.[0]}</span>
                  </div>
                )}
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    {a.category && (
                      <span className="text-[10px] font-sans font-medium px-2 py-0.5 rounded-full bg-[#5C715E]/10 text-[#5C715E] uppercase tracking-wider capitalize">
                        {a.category}
                      </span>
                    )}
                    {a.publish_date && (
                      <span className="text-[10px] font-sans text-[#2A3324]/30 flex items-center gap-1">
                        <Calendar size={10} /> {new Date(a.publish_date).toLocaleDateString()}
                      </span>
                    )}
                  </div>
                  <h3 className="text-lg font-serif font-normal text-[#2A3324] mb-2 group-hover:text-[#5C715E] transition-colors line-clamp-2">
                    {a.title}
                  </h3>
                  <p className="text-sm font-sans font-light text-[#2A3324]/50 line-clamp-2 mb-4">
                    {a.meta_description}
                  </p>
                  <span className="text-xs font-sans font-medium text-[#C47C5D] flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read Article <ArrowRight size={14} />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <button
          onClick={() => navigate("/blog")}
          className="md:hidden mt-8 mx-auto flex items-center gap-2 text-sm font-sans font-medium text-[#5C715E] hover:text-[#4A5A4B]"
        >
          View All Articles <ArrowRight size={16} />
        </button>
      </div>
    </section>
  );
}
